import VRMessageController from "./VRMessage-controller";
import VRInformation from "./message/VRInformation";
import {VRInformationModeEnum} from "./VRMessageLiterals"

class VRInformationController extends VRMessageController {
    constructor(props) {
        super(props);
        this.messages = [];
    }

    async createMessage(properties) {
        let vrMessage = new VRInformation(properties);
        await vrMessage.setPosition();
        vrMessage.show();
        this.messages.push(vrMessage);

        setTimeout(() => {
            this.removeMessage(vrMessage);
        }, vrMessage.duration);
    }

    deallocatePosition(position, messageIndex) {
    }


    hideMessageBeforeVRModeChange() {
        for (const message of this.messages) {
            message.hideMessage();
        }
    }

    onWindowResize() {
        const configDataList = this.messages.map(message => message.configData);
        this.removeAllMessage(false);
        for (const config of configDataList) {
            this.createMessage(config);
        }
    }


    onVRModeChange() {
        for (const message of this.messages) {
            message.showMessage();
            const configData = message.configData;
            if (this.shouldMessageDisposeAndCreate(configData)) {
                this.removeMessage(message);
                this.createMessage(configData);
            } else if (configData.VRMode !== configData.NonVRMode) {
                message.updateVRMessageParent();
                message.updateScalingAndPosition();
            } else {
                message.updateScalingAndPosition();
            }

        }
    }

    shouldMessageDisposeAndCreate(configData) {
        const {VRMode, NonVRMode, Camera} = configData;
        let currentMode = isVRConnected() ? VRMode : NonVRMode;

        return (
            (VRMode !== NonVRMode) &&
            (
                currentMode === VRInformationModeEnum.CAMERA_FIX && (Camera && (Camera.maxHeight || Camera.maxWidth))
            )
        );
    }

}

export default VRInformationController;